import PersonalInformations from '@features/profile/profile-information/profile-information';
import Box from '@mui/material/Box';

const Profie = (): JSX.Element => {
  return (
    <Box sx={{ width: '100%' }}>
      <PersonalInformations />
    </Box>
  );
};

export default Profie;
